<template>
  <div class="view">
    <Title title="観光ポイント"/>
    <TourismNewMain />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import TourismNewMain from '@/components/Tourism/NewMain'

export default {
  components: {
    Title,
    TourismNewMain
  }
}
</script>
